// extracted by mini-css-extract-plugin
module.exports = {"outer":"epShK","stayOuter":"_2lxu_","usedCarWrapper":"_1Dh3R","twoBannersWrapper":"_2hZxK","recommendedWrapper":"_9fsnO","surveyContainer":"_2zEe7"};